import { requirementSchema } from '@/features/settings/requirements/schema'
import { z } from 'zod'

export const categoryFormSchema = z.object({
  categoryName: z.string().min(1, 'Category name is required').max(100),
  description: z.string().min(0, 'Description is required').max(500).optional(),
  annualFee: z.number().min(1, 'Annual fee must be positive'),
  active: z.boolean().default(true),
  targetAudience: z.string().optional(),
  requirements: z.array(requirementSchema).optional().default([]),
})

export type CategoryFormValues = z.infer<typeof categoryFormSchema>
